import React, { useEffect } from "react";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import Container from "../../../../../vendors/components/Container";
import Field from "../../../../../vendors/components/Field";
import { InputText } from "primereact/inputtext";
import AnttButton from "../../../../../vendors/components/Button";
import DispositivoItem from "../../../../components/dispositivo/DispositivoItem";
import EventoFinalizar from "../../../../components/evento-finalizar/EventoFinalizar";
import ModalContribuirVarios from "./ModalContribuirVarios";
import FilaContribuicaoUtil from "../../../../shared/utils/FilaContribuicaoUtil";
import { formatDate } from "../../../../../vendors/pipe/DataPipe";
import DataUtil from "../../../../../vendors/shared/utils/DataUtil";

interface Props {
  controller: EventoVisualizarController;
  isBlock: any;
}

export default function Contribuir({ controller, isBlock }: Props) {
  const evento = controller.evento;
  const [filter, setFilter] = React.useState("");
  const [lista, setLista]: any = React.useState([]);

  useEffect(
    () => {
      if (
        !!controller.evento &&
        !!controller.evento.dispositivoList &&
        controller.evento.dispositivoList.length > 0
      ) {
        setLista(
          [...controller.evento.dispositivoList].sort((a, b) =>
            a.nuOrdem > b.nuOrdem ? 1 : -1
          )
        );
      }
    },
    [controller.evento.dispositivoList].sort((a, b) =>
      a.nuOrdem > b.nuOrdem ? 1 : -1
    )
  );

  const permiteContribuir = () => {
    if (
      DataUtil.formataLocalDateTime(new Date()) >= evento.dtInicioValidade &&
      DataUtil.formataLocalDateTime(new Date()) <= evento.dtFimValidade
    ) {
      return false;
    } else {
      return true;
    }
  };

  const filtrarDispositivos = () => {
    const _filter = filter.toLowerCase().trim();

    setFilter(_filter);
    if (!_filter || _filter.length === 0) {
      let _lista = [...controller.evento.dispositivoList];
      _lista = _lista.sort((a, b) => (a.nuOrdem > b.nuOrdem ? 1 : -1));
      setLista(_lista);
      return;
    }

    let _lista = [...controller.evento.dispositivoList];
    _lista = _lista.filter(
      (f) =>
        f.dsDispositivo.toLowerCase().includes(_filter) || f.nuOrdem == _filter
    );
    _lista = _lista.sort((a, b) => (a.nuOrdem > b.nuOrdem ? 1 : -1));
    setLista(_lista);
  };

  const handleModalLogin = (id?: number | null) => {
    controller.abrirModalLogin({
      id: id,
      codAudienciaPublica: evento.codAudienciaPublica,
    });
  };

  return (
    <>
      <If condition={controller.tab === "contribuir"}>
        <Card className="evento-vis-card-tab" title="Buscar tópicos">
          <Container style={{ margin: "0" }} className="no-spaces">
            <Field className="no-spaces" col={12}>
              <InputText
                value={filter}
                maxLength={200}
                onChange={(event) => setFilter(event.target.value)}
              />
            </Field>
          </Container>
          <div className="flex justify-content-end mt-2">
            <AnttButton
              onClick={() => filtrarDispositivos()}
              label="Pesquisar"
            />
          </div>
        </Card>
        <div
          className="evento-vis-card-tab"
          style={{ height: "100%", padding: 12 }}
        >
          <If
            condition={
              controller.evento.codSituacaoAudiencia !== 5 &&
              !permiteContribuir() &&
              lista.length > 0
            }
          >
            <ModalContribuirVarios
              codAudienciaPublica={evento.codAudienciaPublica}
              lista={lista}
              isBlock={isBlock}
              handleModalLogin={() => handleModalLogin(null)}
            />
          </If>
          <div className="flex justify-content-end">
            <label
              style={{ color: "var(--azul-primario-claro)", fontSize: "16px" }}
            >
              {
                lista.filter(
                  (m: any) => m.dsDispositivo != "ContribuicaoOutrosMeios"
                ).length
              }{" "}
              <span>
                {lista.length > 1 || lista.length == 0 ? " tópicos" : " tópico"}
              </span>
            </label>
          </div>
          <div className="evento-full">
            {lista.length > 0 ? (
              (() => {
                const semTema = lista.filter(
                  (m: any) =>
                    m.dsDispositivo !== "ContribuicaoOutrosMeios" &&
                    !m.cdSeqTema
                );
                const comTemaMap = lista
                  .filter(
                    (m: any) =>
                      m.dsDispositivo !== "ContribuicaoOutrosMeios" &&
                      !!m.cdSeqTema
                  )
                  .reduce((acc: any, m: any) => {
                    const temaKey = m.cdSeqTema;
                    if (!acc[temaKey]) {
                      acc[temaKey] = {
                        nome:
                          m.cdSeqTemaNavigation?.dsTema || `Tema ${temaKey}`,
                        items: [],
                      };
                    }
                    acc[temaKey].items.push(m);
                    return acc;
                  }, {} as Record<number, { nome: string; items: any[] }>);
                const temaGroups = Object.values(comTemaMap) as {
                  nome: string;
                  items: any[];
                }[];
                let globalIndex = 0;

                const renderItem = (m: any) => {
                  const idx = globalIndex++;
                  return (
                    <DispositivoItem
                      key={`dispositivo-item-${m.codDispositivo}`}
                      index={idx}
                      value={m}
                      eventoAberto={
                        controller.evento.codSituacaoAudiencia !== 5
                      }
                      handleClick={() => {
                        FilaContribuicaoUtil.limparFila();
                        if (isBlock) {
                          // controller.abrirModalLogin({
                          //   id: m.codDispositivo,
                          //   codAudienciaPublica: evento.codAudienciaPublica,
                          // });
                          handleModalLogin(m.codDispositivo);
                        } else {
                          if (
                            sessionStorage.getItem("idEventoInterno") != null
                          ) {
                            controller.history.push(
                              "/evento-interno-contribuicao",
                              {
                                id: m.codDispositivo,
                                codAudienciaPublica: evento.codAudienciaPublica,
                              }
                            );
                          } else {
                            controller.history.push("/evento/contribuicao", {
                              id: m.codDispositivo,
                              codAudienciaPublica: evento.codAudienciaPublica,
                            });
                          }
                        }
                      }}
                      evento={evento}
                      hideButton={permiteContribuir()}
                    />
                  );
                };

                return (
                  <>
                    {/* Dispositivos sem tema primeiro */}
                    {semTema.map((m: any) => renderItem(m))}

                    {/* Depois cada grupo de tema */}
                    {temaGroups.map((grupo) => (
                      <div key={grupo.nome} className="mt-3">
                        <div
                          style={{
                            padding: "8px 16px",
                            backgroundColor: "var(--surface-100)",
                            borderLeft: "3px solid var(--primary-color)",
                            fontWeight: 600,
                            fontSize: "0.95rem",
                            color: "var(--text-color)",
                          }}
                        >
                          {grupo.nome}
                        </div>
                        {grupo.items.map((m: any) => renderItem(m))}
                      </div>
                    ))}
                  </>
                );
              })()
            ) : (
              <div className="text-center" style={{ margin: "20px 0" }}>
                Nenhum registro encontrado
              </div>
            )}
          </div>
          <div
            className="flex justify-content-between"
            style={{ padding: "10px" }}
          >
            <AnttButton
              label="Download de todos os tópicos"
              onClick={() => controller.getRelatorio()}
              className="p-button p-button-secondary"
            />
            <If condition={!isBlock}>
              <EventoFinalizar evento={evento} />
            </If>
          </div>
        </div>
      </If>
    </>
  );
}
